<template>
    <div class="details">
        <div class="heads m-b-20">
            <van-steps class="setepsList" :active="active" active-icon="success" active-color="#38f">
                <van-step v-for="(item, index) in tipList" :key="index" v-on:click.native="tabPage(index)">{{item}}</van-step>
            </van-steps>
        </div>
        <measureInfo v-if="index == 0"></measureInfo>
        <designInfo v-if="index == 1"></designInfo>
        <contractInfo v-if="index == 2"></contractInfo>
        <installInfo v-if="index == 3"></installInfo>
        <!-- <div class="getPayment">
            <div class="flex-row paymentItem m-r-53 sumPirce">
                <p>商品总价:</p>
                <p>￥60000</p>
            </div>
            <div class="flex-row paymentItem m-r-33 actualPrice">
                <p>实际付款:</p>
                <p class="fontColor">￥60000</p>
            </div>
        </div> -->
    </div>
</template>
<script>
import { Step, Steps } from 'vant';
import measureInfo from '@/views/order/componets/measureInfo.vue';
import designInfo from '@/views/order/componets/designInfo.vue';
import contractInfo from '@/views/order/componets/contractInfo.vue';
import installInfo from '@/views/order/componets/installInfo.vue';
import { getOrderDetail } from '@/api/index';
export default {
    components:{
        [Step.name] : Step,
        [Steps.name] : Steps,
        measureInfo,
        designInfo,
        contractInfo,
        installInfo
    },
    data(){
        return{
            active: 0,
            tipList: ['测量', '设计', '下单', '安装', '完成'],
            index: 0
        }
    },
    created(){
        // this.getInfo(0);
        this.index = this.active;
    },
    methods:{
        tabPage(index){
            this.index = index;
        },
        // getInfo(num){
        //     getOrderDetail({orderId: this.$route.query.id, orderNode: num}).then(res => {
        //         console.log(res);
        //     }).catch(error => {
        //         console.log('获取订单详情 views/order/orderDetails')
        //     })
        // }
    }
}
</script>

<style lang="scss" scoped>
.details{
    background: $color-ed;
    width: 100vw;
    overflow: hidden;
    padding-bottom: 20px;
}
.heads{
    width: 100vw;
    padding:10px 0;
    background: $ffff; 
    overflow-x:scroll;
    .setepsList{
        width: 150%;
    }
}
.getPayment{
    width: 100%;
    background: $ffff;
    padding: 30px 0; 
    .paymentItem{
        justify-content: flex-end;
        margin-bottom: 26px;
    }
    .sumPirce{
        font-size: 24px;
        font-weight: 400;
        color: $color-102;
        line-height: 70px;
    }
}
.actualPrice{
    font-size: 28px;
    color: $color-51;
}
.fontColor{
    color: $color-36;
}
</style>

